import LazyLoader from 'components/LazyLoader/LazyLoader'

export default LazyLoader
